import { useSearchContext } from '@cox/core-ui8/dist/SearchContext'

import ReactCFConditionalList from './ReactCFConditionalList'
import ReactCFGroupedStaticList from './ReactCFGroupedStaticList'
import ReactCFStaticList from './ReactCFStaticList'
import ReactDifferentIconList from './ReactDifferentIconList'
import ReactFeaturedCategoryList from './ReactFeaturedCategoryList'
import ReactInversionList from './ReactInversionList'
import ReactStandardList from './ReactStandardList'
import ReactStoreLocatorList from './ReactStoreLocatorList'
import { ListType, ReactListProps } from './types'
import { getSpacing } from '../../utils/spacing-util'
import IsInEditorText from '../shared/IsInEditorText'

const ReactList = (props: ReactListProps): JSX.Element => {
  const {
    listFrom,
    isInEditor = false,
    id = '',
    top = false,
    right = false,
    bottom = false,
    left = false,
    lob = '',
    hideMCP = false
  } = props

  // Show featured category if there is no search results or API error
  const { hasNoLinksSearchResults, hasNoGenSearchResults, isSearch } = useSearchContext()
  let displayFeaturedCategory = hasNoLinksSearchResults

  if (hasNoLinksSearchResults && !hasNoGenSearchResults) {
    displayFeaturedCategory = false
  }

  const getList = () => {
    switch (listFrom) {
      case ListType.featuredCategory:
        return <ReactFeaturedCategoryList {...props} />
      case ListType.differentIcons:
        return <ReactDifferentIconList {...props} />
      case ListType.static:
        return <ReactStandardList {...props} />
      case ListType.cfStandardList:
        return <ReactCFStaticList {...props} />
      case ListType.cfConditionalList:
        return <ReactCFConditionalList {...props} />
      case ListType.cfGroupedStaticList:
        return <ReactCFGroupedStaticList {...props} />
      case ListType.inversionList:
        return <ReactInversionList />
      case ListType.storeLocatorList:
        return <ReactStoreLocatorList {...props} />
      default:
        return <></>
    }
  }

  if (isSearch && !displayFeaturedCategory) {
    return <>{IsInEditorText(isInEditor, 'React List')}</>
  }

  // Checks if hideMCP flag is true and that display is in dispatcher, not in author:
  const mcpClass = hideMCP && isInEditor == false ? 'd-none' : ''

  return (
    <div
      data-testid={`react-list-container`}
      className={`react-list-container ${getSpacing(top, right, bottom, left)} ${lob} ${mcpClass}`}
      id={id}
    >
      {IsInEditorText(isInEditor, ' React List')}
      {getList()}
    </div>
  )
}

export default ReactList
